import Box from "@mui/material/Box";
import { Fragment } from "react";
import { useContent } from "../app/ContentContext";
import Typography from "@mui/material/Typography";
import PageHeader from "../components/PageHeader";

const Appointment = () => {
  const { appointmentInfo, appointmentPage } = useContent();
  return (
    <Box sx={{ pb: 5 }}>
      <PageHeader
        title={appointmentPage.title}
        description={appointmentPage.description}
      />
      <Box sx={{ maxWidth: "560px", mx: "auto", px: 2 }}>
        {appointmentInfo.map((info, index) => (
          <Fragment key={index}>
            <Typography
              variant="h5"
              color="secondary.main"
              sx={{ mt: 3, mb: 1 }}
            >
              {info.title}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ lineHeight: 1.7 }}
            >
              {info.description}
            </Typography>
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default Appointment;
